module.exports = __webpack_public_path__ + "img/dle.a69eeb07.svg";